export default [
  {
    path: "/app/school-meals",
    component: () => import("../views"),
    meta: {
      title: "Educasis - Alimentação Escolar",
      requiresAuth: true,
    },
    children: [

      // Register
      /* Products */
      {
        path: "register/products",
        name: "school-meals.register.products",
        component: () => import("../register/products/views/List.vue"),
        meta: {
          permission: "view_products",
        },
      },
      {
        path: "register/products/create",
        name: "school-meals.register.products.create",
        component: () => import("../register/products/views/Create.vue"),
        meta: {
          permission: "view_products",
        },
      },
      {
        path: "register/products/edit/:id",
        name: "school-meals.register.products.edit",
        component: () => import("../register/products/views/Edit.vue"),
        meta: {
          permission: "view_products",
        },
      },
      {
        path: "register/products/show/:id",
        name: "school-meals.register.products.show",
        component: () => import("../register/products/views/Show.vue"),
        meta: {
          permission: "view_products",
        },
      },
      /* Types */
      /* Unities */
      {
        path: "register/types/unities",
        name: "school-meals.register.types.unities",
        component: () => import("../register/types/unities/views/List.vue"),
        meta: {
          permission: "view_unities",
        },
      },
      {
        path: "register/types/unities/create",
        name: "school-meals.register.types.unities.create",
        component: () => import("../register/types/unities/views/Create.vue"),
        meta: {
          permission: "view_unities",
        },
      },
      {
        path: "register/types/unities/edit/:id",
        name: "school-meals.register.types.unities.edit",
        component: () => import("../register/types/unities/views/Edit.vue"),
        meta: {
          permission: "view_unities",
        },
      },
      {
        path: "register/types/unities/show/:id",
        name: "school-meals.register.types.unities.show",
        component: () => import("../register/types/unities/views/Show.vue"),
        meta: {
          permission: "view_unities",
        },
      },

      /* Management */
      /* Assemble-Menu */
      {
        path: "management/assemble-menu",
        name: "school-meals.management.assemble-menu",
        component: () => import("../management/assemble-menu/views/List.vue"),
        meta: {
          permission: "view_snack_menu",
        },
      },
      {
        path: "management/assemble-menu/create",
        name: "school-meals.management.assemble-menu.create",
        component: () => import("../management/assemble-menu/views/Create.vue"),
        meta: {
          permission: "view_snack_menu",
        },
      },
      {
        path: "management/assemble-menu/edit/:id",
        name: "school-meals.management.assemble-menu.edit",
        component: () => import("../management/assemble-menu/views/Edit.vue"),
        meta: {
          permission: "view_snack_menu",
        },
      },
      {
        path: "management/assemble-menu/show/:id",
        name: "school-meals.management.assemble-menu.show",
        component: () => import("../management/assemble-menu/views/Show.vue"),
        meta: {
          permission: "view_snack_menu",
        },
      },
      /* Menu-Class */
      {
        path: "management/menu-class",
        name: "school-meals.management.menu-class",
        component: () => import("../management/menu-class/views/List.vue"),
        meta: {
          permission: "view_menu_class",
        },
      },

      /* Queries */
      /* Applied-Menu */
      {
        path: "queries/applied-menus",
        name: "school-meals.queries.applied-menus",
        component: () => import("../queries/applied-menus/views/AppliedMenuMap.vue"),
        meta: {
          permission: "view_snack_menu",
        },
      },
    ],
  },
];
